import BaseView from '../../base-view';
import ToggleMixin from '../../mixins/toggle';
import Collection from './collection';
import HeaderView from './header/view';
import ListView from './list/view';

export default BaseView.extend({

	// mixin toggle functionality
	mixins: [ToggleMixin],

	initialize: function() {
		// create collection with bootstrapped data
		var sidebarData = window.sidebarModelData || {};
		this.collection = new Collection(sidebarData, { parse: true });

		// create subview
		this.headerView = new HeaderView({
			el: this.query('.js-alerts-header'),
			collection: this.collection
		});

		this.listView = new ListView({
			el: this.query('.js-alerts-list'),
			collection: this.collection
		});

		// reference elements
		this.form = this.query('.js-alerts-form');
		this.noNotifications = this.query('.js-no-notifications');

		// listeners
		this.listenTo(this.headerView, 'alerts:submit', this.submitForm);
		this.listenTo(this.collection, 'add', this.onCollectionChange);
		this.listenTo(this.collection, 'remove', this.onCollectionChange);
	},

	/**
	 * Submit the form from the header
	 **/
	submitForm: function(action) {
		this.form.setAttribute('action', action);
		this.form.submit();
	},

	/**
	 * Collection change handler
	 **/
	onCollectionChange: function() {
		// toggle 'no notifications' message
		this.noNotifications.classList.toggle('is-hidden', this.collection.length !== 0);
	}
});

